import { render, staticRenderFns } from "./UDEquip.vue?vue&type=template&id=ebc5f1ea"
import script from "./UDEquip.vue?vue&type=script&lang=js"
export * from "./UDEquip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports